import { List, Record } from 'immutable';

const includedInListFilter = (allowedMatches, extractor) => (
  obj => allowedMatches.isEmpty() || allowedMatches.includes(extractor(obj))
);

const stringMatchFilter = (searchString, extractor) => {
  if (!searchString || searchString === '') {
    return () => true;
  }

  const search = searchString.toLowerCase();
  return obj => (
    extractor(obj) ? extractor(obj).toLowerCase().includes(search) : false
  );
};

const excludeStringMatchFilter = (excludeString, extractor) => (
  obj => !stringMatchFilter(excludeString, extractor)(obj)
);

const makeFilter = filters => obj => filters.every(filt => filt(obj));


// Actual filters for FilteredFooStores
// Pairs filter object members with extractors for the objects
// and applies the appropriate filter function
export const makeJobFilter = jobFilter => (
  makeFilter(List.of(
    stringMatchFilter(jobFilter.nameSearch, job => job.name),
    includedInListFilter(jobFilter.allowedStatuses, job => job.status),
    includedInListFilter(jobFilter.allowedOwners, job => job.creator),
  ))
);

export const makeSavedJobFilter = savedJobsFilter => (
  makeFilter(List.of(
    stringMatchFilter(savedJobsFilter.nameSearch, savedJob => savedJob.name),
    excludeStringMatchFilter('cross channel:', savedJob => savedJob.name),
  ))
);

export const makeSyncFilter = syncFilter => (
  makeFilter(List.of(
    stringMatchFilter(syncFilter.nameSearch, sync => sync.tableName),
    includedInListFilter(syncFilter.allowedStatuses, sync => sync.status),
  ))
);

export const JobFilters = Record({
  allowedOwners: new List(),
  nameSearch: '',
  allowedStatuses: new List(),
});

export const SavedJobsFilters = Record({
  nameSearch: '',
});

export const SyncFilters = Record({
  nameSearch: '',
  allowedStatuses: new List(),
});
